import React from 'react';
import { useAPIContext } from '../../context/api';
import { WidgetSettings } from '../../../../types/widget-settings';
import { SettingsAPI } from '../../../../constructs/settings/interface';

interface UseWidgetSettingsProps {
  widgetId?: string; // Opcional: si no viene, maneja settings del cliente
}

export const useWidgetSettings = ({ widgetId }: UseWidgetSettingsProps = {}) => {
  const { callEndpoint } = useAPIContext();

  const saveSettings = React.useCallback(
    async (settings: WidgetSettings) => {
      try {
        const path = widgetId ? `/widget/${widgetId}` : '/client';

        const res = await callEndpoint<SettingsAPI, 'save-settings'>('settings', path, 'POST', { settings });

        if (!res) throw new Error('Respuesta del servidor inesperada al guardar la configuración');
        return res;
      } catch (error: any) {
        console.error('Error saving settings:', error);
        return false; // el hook NO muestra mensajes
      }
    },
    [widgetId, callEndpoint]
  );

  const getSettings = React.useCallback(async () => {
    try {
      const path = widgetId ? `/widget/${widgetId}` : '/PUBLISHERS';

      const res = await callEndpoint<SettingsAPI, 'get-settings'>('settings', path, 'GET');

      if (!res) throw new Error('Respuesta del servidor inesperada al obtener la configuración');
      return res;
    } catch (error: any) {
      console.error('Error getting settings:', error);
      return false; // el hook NO muestra mensajes
    }
  }, [callEndpoint, widgetId]);

  return {
    saveSettings,
    getSettings
  };
};
